import type { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="copy"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={17}
    viewBox="0 0 15 17"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12.187 5.583H6.09a.508.508 0 0 0-.508.508v8.127c0 .28.228.508.508.508h6.096c.28 0 .508-.227.508-.508V6.091a.508.508 0 0 0-.508-.508ZM6.09 4.06c-1.122 0-2.031.91-2.031 2.031v8.127c0 1.122.91 2.032 2.031 2.032h6.096c1.122 0 2.031-.91 2.031-2.032V6.091c0-1.122-.91-2.031-2.031-2.031H6.09Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M.25 3.044A2.794 2.794 0 0 1 3.044.25h8.127v1.524H3.044a1.27 1.27 0 0 0-1.27 1.27v10.158H.25V3.044Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
